/* eslint-disable @typescript-eslint/ban-types */
import { Applicant } from '@flatsy/types/Applications'
import { convertProSituationIntoProStatus } from '@flatsy/utils/Functions/ApplicationUtils/ProfessionalSituation/Converter'
import { booleanOrUndefined } from './Format/booleanOrUndefined'
import { shouldResetApplicantDuration } from './Format/shouldResetApplicantDuration'
import { stringOrUndefined } from './Format/stringOrUndefined'

export const sanitizeApplicant = (applicant: Applicant): Applicant => {
  const finalObject: Applicant = {
    applicant_id: applicant.applicant_id,
    id: applicant.id,
    kind: applicant.kind,
  }
  const object: Applicant = {
    ...applicant,
    french_resident: booleanOrUndefined(applicant.french_resident),
    first_name: stringOrUndefined(applicant.first_name),
    last_name: stringOrUndefined(applicant.last_name),
    phone_number: stringOrUndefined(applicant.phone_number),
    email: stringOrUndefined(applicant.email),
    social_security_number: stringOrUndefined(applicant.social_security_number),
    probation: booleanOrUndefined(applicant.probation),
    revenue: stringOrUndefined(applicant.revenue),
    revenue_reference: stringOrUndefined(applicant.revenue_reference),
    has_guarantor: booleanOrUndefined(applicant.has_guarantor),
    guarantor_kind: stringOrUndefined(applicant.guarantor_kind),
    duration: stringOrUndefined(applicant.duration),
  }

  if (stringOrUndefined(applicant?.professional_situation)) {
    object.situation = convertProSituationIntoProStatus(
      stringOrUndefined(applicant?.professional_situation),
      stringOrUndefined(applicant?.situation)
    )
  } else {
    object.situation = undefined
  }

  if (object.french_resident !== undefined) {
    finalObject.french_resident = object.french_resident
  }

  if (object.first_name !== undefined) {
    finalObject.first_name = object.first_name
  }

  if (object.last_name !== undefined) {
    finalObject.last_name = object.last_name
  }

  if (object.phone_number !== undefined) {
    finalObject.phone_number = object.phone_number
  }

  if (object.email !== undefined) {
    finalObject.email = object.email
  }

  if (object.social_security_number !== undefined) {
    finalObject.social_security_number = object.social_security_number
  }

  if (object.probation !== undefined) {
    finalObject.probation = object.probation
  }

  if (object.revenue !== undefined) {
    finalObject.revenue = object.revenue
  }

  if (object.revenue_reference !== undefined) {
    finalObject.revenue_reference = object.revenue_reference
  }

  if (object.has_guarantor !== undefined) {
    finalObject.has_guarantor = object.has_guarantor
  }

  if (object.guarantor_kind !== undefined) {
    finalObject.guarantor_kind = object.guarantor_kind
  }

  if (object.duration !== undefined) {
    finalObject.duration = object.duration
  }
  if (object.situation !== undefined) {
    finalObject.situation = object.situation
  }

  if (shouldResetApplicantDuration(applicant.situation)) {
    finalObject.duration = null
  }

  return finalObject
}
